var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "demage-modal",
    attrs: {
      title: (_vm.status === "add" ? _vm.$t("添加") : _vm.$t("编辑")) + _vm.$t("文件"),
      visible: _vm.addVisible,
      width: 850
    },
    on: {
      cancel: _vm.closeAddVisible
    }
  }, [_c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      model: _vm.addForm,
      rules: _vm.ADD_RULES,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件说明"),
      prop: "description"
    }
  }, [_c("a-textarea", {
    attrs: {
      rows: 3,
      allowClear: ""
    },
    model: {
      value: _vm.addForm.description,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "description", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.description"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件格式"),
      prop: "format"
    }
  }, [_c("div", [_c("a-checkbox", {
    attrs: {
      indeterminate: _vm.indeterminate,
      checked: _vm.checkAll
    },
    on: {
      change: _vm.onCheckAllChange
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("全选")) + " ")])], 1), _c("a-checkbox-group", {
    attrs: {
      options: _vm.plainOptions
    },
    on: {
      change: _vm.onChangeFormat
    },
    model: {
      value: _vm.addForm.format,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "format", $$v);
      },
      expression: "addForm.format"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件模板"),
      prop: "fileList"
    }
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      action: _vm.action,
      accept: _vm.uploadAccept,
      remove: _vm.removeUploadFile,
      "open-file-dialog-on-click": _vm.fileDialog,
      "file-list": _vm.addForm.fileList,
      "list-type": "picture-card",
      data: {
        module: "claimsFile"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      preview: _vm.handlePreview,
      change: _vm.changeUpload
    }
  }, [_c("div", {
    staticClass: "upload-icon",
    on: {
      click: _vm.clickPlus
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  })], 1)])], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("模板说明"),
      prop: "templateDesc"
    }
  }, [_c("a-textarea", {
    attrs: {
      rows: 3,
      allowClear: "",
      placeholder: _vm.$t("请说明此模版适用于某个产品或某个承保机构")
    },
    model: {
      value: _vm.addForm.templateDesc,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "templateDesc", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.templateDesc"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("排序"),
      prop: "sort"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      min: 0
    },
    model: {
      value: _vm.addForm.sort,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "sort", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.sort"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      size: "small",
      loading: _vm.saveLoading,
      disabled: _vm.saveLoading
    },
    on: {
      click: _vm.saveAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.saveLoading ? "" : _vm.$t("保存")) + " ")]), _vm.status === "add" && _vm.isContinue ? _c("a-checkbox", {
    attrs: {
      checked: _vm.continueState
    },
    on: {
      change: _vm.onContinueToAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("继续添加")) + " ")]) : _vm._e()], 1), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible,
      videoTypeList: ["avi", "mov", "rm", "mp4", "rmvb"],
      fileList: _vm.addForm.fileList,
      show: _vm.isShow,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };